export enum JobPostingSortableField {
  PublishedAt = 'publishedAt',
  HireCount = 'hireCount',
}
